<script setup lang="ts">
    const emit = defineEmits<{
        'suggestion-clicked': [text: string];
    }>();
    const { t } = useTranslation();

    const SUGGESTION_KEYS: string[] = ['ai.suggestions.what_info_needed', 'ai.suggestions.list_prices', 'ai.suggestions.what_can_you_do'];

    const suggestions = computed(() => {
        return SUGGESTION_KEYS.map((key) => t(key));
    });
</script>

<template>
    <div class="flex flex-wrap justify-center gap-[10px] max-w-[640px]">
        <button
            v-for="suggestion in suggestions"
            :key="suggestion"
            type="button"
            class="px-[14px] py-[8px] rounded-full bg-white border border-[#E7E7E7] font-inter text-[12px] text-[#42484E] shadow-[0_1px_2px_rgba(0,0,0,0.03)] hover:border-[#FFC400] hover:text-[#0F1020] transition-all cursor-pointer"
            @click="emit('suggestion-clicked', suggestion)"
        >
            {{ suggestion }}
        </button>
    </div>
</template>
